import IPagination from '@interfaces/IPagination';
import BasePaginationQuery from '@interfaces/base-pagination-query';
import BaseService, { RequestInterface } from './Base';
import { AwsConfig as AwsConstants } from './Constants';
import { Dashboard } from '../../src/interfaces/ehss/Dashboard'
import DashboardQuery from '../../src/interfaces/ehss/dashboard-query'


export default class ProcessManagementService extends BaseService {
    constructor() {
        super(AwsConstants.API_CONFIG, 'ticket-event');
    }

    async pagingProcess(query: BasePaginationQuery, fields?: string[]): Promise<IPagination<any>> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        if (query.unit) {
            params.queryStringParameters['unit'] = query.unit;
        }
        if (query.status) {
            params.queryStringParameters['status'] = query.status;
        }
        if (query.limit) {
            params.queryStringParameters['limit'] = query.limit;
        }
        if (query.offset) {
            params.queryStringParameters['offset'] = query.offset;
        }
        if (query.from) {
            params.queryStringParameters['from'] = query.offset;
        }
        if (query.to) {
            params.queryStringParameters['to'] = query.offset;
        }
        if (query.search) {
            params.queryStringParameters['search'] = query.search; // by name
        }

        const res = await super.get<IPagination<any>>('process', params);
        return res;
    }

    async getProcessComponent(processId: string, componentID: string, query: DashboardQuery): Promise<Dashboard> {
        const params: RequestInterface = {
            queryStringParameters: {}
        };

        if (query.unit) {
            params.queryStringParameters['unit'] = query.unit;
        }
        if (query.from) {
            params.queryStringParameters['from'] = query.from;
        }
        if (query.to) {
            params.queryStringParameters['to'] = query.to;
        }

        const res = await super.get<Dashboard>(`dashboard/process/${processId}/component/${componentID}`, params);
        return res;
    }

    async getDashboard(query: DashboardQuery, processId: string): Promise<Dashboard[]> {
        const params: RequestInterface = {
            queryStringParameters: {}
        };

        if (query.unit) {
            params.queryStringParameters['unit'] = query.unit;
        }
        if (query.from) {
            params.queryStringParameters['from'] = query.from;
        }
        if (query.to) {
            params.queryStringParameters['to'] = query.to;
        }
        if (query.field) {
            params.queryStringParameters['field'] = query.field;
        }
        if (query.value) {
            params.queryStringParameters['value'] = query.value;
        }
        if (query.process) {
            params.queryStringParameters['process'] = query.process;
        }
        if (query.auditor) {
            params.queryStringParameters['auditor'] = query.auditor;
        }
        if (query.audited) {
            params.queryStringParameters['audited'] = query.audited;
        }
        if (query.auditedOut) {
            params.queryStringParameters['auditedOut'] = query.auditedOut;
        }
        if (query.auditorGuest) {
            params.queryStringParameters['auditorGuest'] = query.auditorGuest;
        }
        if (query.status) {
            params.queryStringParameters['status'] = query.status;
        }
        const res = await super.get<Dashboard[]>(`dashboard/process/${processId}`, params);
        return res;
    }
    async getDashboardRisk(query: DashboardQuery, processId: string, infoId: string): Promise<Dashboard[]> {
        const params: RequestInterface = {
            queryStringParameters: {}
        };

        if (query.unit) {
            params.queryStringParameters['unit'] = query.unit;
        }
        if (query.from) {
            params.queryStringParameters['from'] = query.from;
        }
        if (query.to) {
            params.queryStringParameters['to'] = query.to;
        }
        if (query.field) {
            params.queryStringParameters['field'] = query.field;
        }
        if (query.value) {
            params.queryStringParameters['value'] = query.value;
        }
        if (query.process) {
            params.queryStringParameters['process'] = query.process;
        }
        if (query.auditor) {
            params.queryStringParameters['auditor'] = query.auditor;
        }
        if (query.audited) {
            params.queryStringParameters['audited'] = query.audited;
        }
        if (query.auditedOut) {
            params.queryStringParameters['auditedOut'] = query.auditedOut;
        }
        if (query.auditorGuest) {
            params.queryStringParameters['auditorGuest'] = query.auditorGuest;
        }
        if (query.status) {
            params.queryStringParameters['status'] = query.status;
        }
        const res = await super.get<Dashboard[]>(`dashboard/process/${processId}/info/${infoId}`, params);
        return res;
    }

    async pagingMeProcess(query: BasePaginationQuery, fields?: string[]): Promise<IPagination<any>> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        if (query.unit) {
            params.queryStringParameters['unit'] = query.unit;
        }
        if (query.status) {
            params.queryStringParameters['status'] = query.status;
        }
        if (query.limit) {
            params.queryStringParameters['limit'] = query.limit;
        }
        if (query.offset) {
            params.queryStringParameters['offset'] = query.offset;
        }
        if (query.from) {
            params.queryStringParameters['from'] = query.offset;
        }
        if (query.to) {
            params.queryStringParameters['to'] = query.offset;
        }
        if (query.search) {
            params.queryStringParameters['search'] = query.search; // by name
        }

        const res = await super.get<IPagination<any>>('me/process', params);
        return res;
    }

    async getById(id: string, unit: string, fields?: string[]): Promise<Ticket> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        params.queryStringParameters['unit'] = unit;
        const res = await super.get<Ticket>(id, params);
        return res;
    }

    async getDashboardAuditorAudited(query: DashboardQuery, processId: string): Promise<Dashboard[]> {
        const params: RequestInterface = {
            queryStringParameters: {}
        };

        if (query.unit) {
            params.queryStringParameters['unit'] = query.unit;
        }
        if (query.from) {
            params.queryStringParameters['from'] = query.from;
        }
        if (query.to) {
            params.queryStringParameters['to'] = query.to;
        }
        if (query.auditor) {
            params.queryStringParameters['auditor'] = query.auditor;
        }
        if (query.audited !== undefined) {
            params.queryStringParameters['audited'] = query.audited;
        }
        if (query.auditedOut) {
            params.queryStringParameters['auditedOut'] = query.auditedOut;
        }
        if (query.auditorGuest) {
            params.queryStringParameters['auditorGuest'] = query.auditorGuest;
        }
        if (query.auditedGuest) {
            params.queryStringParameters['auditedGuest'] = query.auditedGuest;
        }
        if (query.status) {
            params.queryStringParameters['status'] = query.status;
        }
        const res = await super.get<Dashboard[]>(`dashboard/process/${processId}/auditor-audited`, params);
        return res;
    }


    async getDashboardData(processID: string, query: any) {

        const params: any = {
            body: {}
        };

        if (query.unit) {
            params.body['unit'] = query.unit
        }
        if (Array.isArray(query.owners) && query.owners.length) {
            params.body['owners'] = query.owners.join(',')
        }
        if (Array.isArray(query.components) && query.components.length) {
            params.body['components'] = query.components.join(',')
        }
        if (Array.isArray(query.status) && query.status.length) {
            params.body['status'] = query.status.join(',')
        }
        if (query.from) {
            params.body['from'] = query.from
        }
        if (query.to) {
            params.body['to'] = query.to
        }
        if (query.hourFrom) {
            params.body['hourFrom'] = query.hourFrom
        }
        if (query.hourTo) {
            params.body['hourTo'] = query.hourTo
        }

        const res = await super.post<any>(`process/${processID}/dashboard`, params)

        return res
    }

}